import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthLocalService } from './auth-local.service';
import { Injectable } from '@angular/core';
import { AuthUtils } from './auth.untils';
import { NavigationService } from '@core/navigation/navigation.service';
import { AppAlertService } from '@shared/services/app/alert.service';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  /**
   * Constructor
   */
  constructor(private _authService: AuthLocalService, private navigationService: NavigationService, private alert: AppAlertService) { }

  /**
   * Intercept
   *
   * @param req
   * @param next
   */
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Clone the request object
    let newReq = req.clone();

    // Request
    //
    // If the access token didn't expire, add the Authorization header.
    // We won't add the Authorization header if the access token expired.
    // This will force the server to return a "401 Unauthorized" response
    // for the protected API routes which our response interceptor will
    // catch and delete the access token from the local storage while logging
    // the user out from the app.
    // if ( this._authService.accessToken && !AuthUtils.isTokenExpired(this._authService.accessToken) )
    // {
    if (this._authService.getCurrentToken() && !AuthUtils.isTokenExpired(this._authService.getCurrentToken())) {

      newReq = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + this._authService.getCurrentToken())
      });
      if (this.navigationService._navigationMenuData.length == 0) {
        this.navigationService.getMenus();
      }
    }

    // Response
    return next.handle(newReq).pipe(
      //  Handle nuevo
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 401) {
            // Token inválido o expirado → desloguear
            this._authService.signOut();
            location.reload();
          } else if (error.status === 0) {
            // Error de red / Service Worker / CORS / offline
            this.alert.error("Ocurrió un error de red o service worker")
          }
        }
        return throwError(() => error);
      })


    );
  }
}
